import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import github from "../assets/img/github.svg";
import ReactGA from "react-ga4";
ReactGA.initialize("G-NY8FSE5QD1");

export const Footer = () => {
  const handleSocialClick = (platform) => {
    ReactGA.event({
      category: "Social Click",
      action: `Clicked ${platform}`,
      label: `${platform} Profile`,
    });
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-start">
          <MailchimpForm />

          <Col size={12} md={4} className="footer-brand">
            <img src={logo} alt="Logo" className="footer-logo" />
            <p className="footer-tagline">
              Building innovative web solutions with passion and precision.
            </p>
          </Col>

          <Col size={12} md={4} className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#connect">Contact</a></li>
            </ul>
          </Col>

          <Col size={12} md={4} className="footer-social">
            <h3>Connect With Me</h3>
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/ushan-mihiranga-b25846296"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleSocialClick("LinkedIn")}
              >
                <img src={navIcon1} alt="LinkedIn Icon" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100077429490019"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleSocialClick("Facebook")}
              >
                <img src={navIcon2} alt="Facebook Icon" />
              </a>
              <a
                href="https://github.com/Ushan2001"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleSocialClick("GitHub")}
              >
                <img src={github} alt="GitHub Icon" />
              </a>
            </div>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col size={12}>
            <div className="footer-divider"></div>
            <p className="copyright">
              © 2025 Ushan Mihiranga. All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
